import * as React from 'react';
import {
    BaseElement,
    BasePlayerContainer,
} from '../components';
import { connect } from 'react-redux';
import { ContainerContext, mapProps } from './index';
import { useNavigate, useParams } from 'react-router';
import { StateMap } from '../reducers';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid2 as Grid } from '@mui/material';
import { Milestone } from './PlayerEditComponent/Milestone';
import { getEditPlayerDataInfo } from '../actions/player';

interface Props extends ContainerContext.Props {
    readonly playerId?: string;
    titleDataItems?: Entities.TitleDataItem[];
    liveEvents?: Entities.LiveEvent[];
    playerData?: Entities.PlayerData[];
}

export class Container extends BaseElement<Props> {
    async componentDidMount() {
        if (this.props.playerId) {
            getEditPlayerDataInfo(this.props.playerId);
        }
    }

    protected renderContainer(): React.JSX.Element {
        const { playerId } = this.props;

        return (
            <BasePlayerContainer
                {...this.props}
                styled={this.props.styled}
                title = {"Player Edit"}
                playerId = {playerId}
                showSubTabs = {true}
            >
                {this.renderContent()}
            </BasePlayerContainer>
        );
    }

    private renderContent() {
        return (
            <Grid size={12}>
                <Grid size={4} style={{
                    backgroundColor: 'white',
                }}>
                    {
                        this.props.playerId
                        && this.props.titleDataItems
                        && this.props.liveEvents
                        && this.props.playerData
                        && <Milestone
                            styled={this.props.styled}
                            playerId={this.props.playerId}
                            titleDataItems={this.props.titleDataItems}
                            liveEvents={this.props.liveEvents}
                            playerData={this.props.playerData}
                        />
                    }
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
    ...state.player.editInfo,
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    const params = useParams();
    const playerId = params.playerId || '';
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate} playerId={playerId}/>);
};
export default connect(mapStateToProps)(AppContainer);
